<template>
    <div class="accordion__group mt-5">
        <div v-if="books.length" v class="text-right mb-3 cursor-pointer" @click="toggleOpen()">
            {{ accordionToggleText }}
        </div>

        <Loader v-if="loading"></Loader>

        <Info v-for="(book, index) in books"
              :key="book.uid"
              :book="book"
              class="primary-text zebra-background"
              :open="openIndex === index || openAll"
              @openChange="$event ? openIndex = index : openIndex = null"
        >
        </Info>
    </div>
</template>

<script>

  import ForfatterInfo from './ForfatterInfo'
  import ForfatterLoader from './ForfatterLoader'

  export default {
    components: {
      Info: ForfatterInfo,
      Loader: ForfatterLoader
    },
    props: {
      books: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        openIndex: null,
        openAll: false,
        accordionToggleText: 'Open All',
      }
    },
    methods: {
      toggleOpen() {
        this.openAll = !this.openAll
        if (this.openAll) {
          this.accordionToggleText = 'Close All'
        }
        else {
          this.accordionToggleText = 'Open All'
        }
      },
      classes(index) {
        return index % 2 === 0 ? 'secondary-background' : 'zebra-background';
      },
    },
  };
</script>
